export class MainMessagePort {
    constructor(port) {
        this.port = port;
        this.dedicatedWorkers = new Map();
        this.onmessage = null;
        this.onmessageerror = null;
        this.onMessageEvent = (ev) => {
            for (const worker of this.dedicatedWorkers.values()) {
                worker.postMessage(ev.data);
            }
            if (this.onmessage === undefined || this.onmessage === null)
                return;
            ev.fromSharedWorker = true;
            this.onmessage(ev);
        };
        this.onErrorEvent = (ev) => {
            if (this.onmessageerror === undefined || this.onmessageerror === null)
                return;
            this.onmessageerror(ev);
        };
        this.onDedicatedMessageEvent = (ev) => {
            if (this.onmessage === undefined || this.onmessage === null)
                return;
            ev.fromDedicatedWorker = true;
            this.onmessage(ev);
        };
        this.onDedicatedErrorEvent = (ev) => {
            if (this.onmessageerror === undefined || this.onmessageerror === null)
                return;
            this.onmessageerror(ev);
        };
    }
    start() {
        this.port.onmessage = this.onMessageEvent;
        this.port.onmessageerror = this.onErrorEvent;
        this.port.start();
    }
    close() {
        this.port.onmessage = null;
        this.port.onmessageerror = null;
        this.port.close();
    }
    postMessage(message, options) {
        for (const dWorker of this.dedicatedWorkers.values()) {
            if (message.workerId === dWorker.workerId)
                continue;
            if (dWorker.postMessage(message, options)) {
                return;
            }
        }
        // options = transfer
        this.port.postMessage(message, options);
    }
    addEventListener(type, listener, options) {
        this.port.addEventListener(type, listener, options);
    }
    removeEventListener(type, listener, options) {
        this.port.removeEventListener(type, listener, options);
    }
    dispatchEvent(event) {
        return this.port.dispatchEvent(event);
    }
    addDedicatedPort(worker) {
        this.dedicatedWorkers.set(worker.workerId, worker);
        worker.onmessage = this.onDedicatedMessageEvent;
        worker.onmessageerror = this.onDedicatedErrorEvent;
    }
    removeDedicatedPort(worker) {
        this.dedicatedWorkers.delete(worker.workerId);
        worker.onmessage = null;
        worker.onmessageerror = null;
    }
}
